import DynamicImage from "@/components/DynamicImages/DynamicImage";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import Link from "next/link";
import AddToCart from "../AddToCart/AddToCart";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "@/components/ui/tooltip";
import { useEffect, useState } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const FrequentlyBoughtTogether = ({
  frequentlyBoughtTogether,
  currentProductImages,
}) => {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) return;

    const updateCount = () => {
      setCount(api.scrollSnapList().length);
      setCurrent(api.selectedScrollSnap() + 1);
    };

    updateCount(); // Initial count and current slide set

    api.on("reInit", updateCount); // Ensure count updates on re-initialization
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });

    return () => {
      api.off("reInit", updateCount);
      api.off("select");
    };
  }, [api]);

  // Function to go to a specific slide when clicking a dot
  const goToSlide = (index) => {
    if (api) {
      api.scrollTo(index);
    }
  };

  return (
    <div className=" my-0 mx-auto py-6">
      <h3 className="text-2xl font-semibold leading-[38px] mb-[21px] px-9 lg:pl-0 lg:text-[16px] lg:leading-[23px] lg:mb-[5px]">
        Frequently Bought Together
      </h3>
      <div className=" bg-white rounded-[10px] py-6 px-3  gap-2 flex lg:flex-wrap lg:gap-[15px] overflow-auto">
        {/* <div className="inline-flex items-center gap-3 border-gray7   lg:pr-0 lg:border-0 mlg:flex-col ">
          {frequentlyBoughtTogether?.map((item, index) => {
            const {
              thumbnail,
              productName,
              pdpSeoUrl,
              productId,
              price_details,
              isInStock,
              webPriceInactive,
            } = item || "";
            const { displayPrice, crossedPrice, cartPrice } =
              price_details || {};
            return (
              <div
                key={index}
                className={cn(
                  "flex items-center  mob:gap-1",
                  frequentlyBoughtTogether.length === index + 1
                    ? "border-none"
                    : "border-r pr-5 mlg:border-r-0 mlg:pb-3 mlg:border-b mlg:pr-0"
                )}
              >
                <div className={cn("inline-flex items-center gap-3")}>
                  <div className="flex gap-3  items-center">
                    <Link href={pdpSeoUrl}>
                      <div className=" w-[132px] h-[132px] mob:w-[74px] mob:h-[74px]">
                        <DynamicImage
                          src={thumbnail}
                          alt="current product"
                          className=" object-contain h-full"
                          width={132}
                          height={132}
                        />
                      </div>
                    </Link>
                  </div>
                  <div className="text-black grid grid-rows-[auto,auto,auto] gap-2 w-[280px]">
                    <h5 className="text-sm mb-1 font-semibold max-w-[350px] w-full min-h-[40px]">
                      {productName}
                    </h5>
                    {!webPriceInactive && (
                      <h3 className="text-[18px] leading-[27px] mb-[14px]">
                        ${cartPrice || displayPrice}{" "}
                        <span className="line-through text-xs">
                          {crossedPrice ? "$" + crossedPrice : ""}
                        </span>
                      </h3>
                    )}
                    <div className="flex justify-start">
                      {!webPriceInactive ? (
                        <AddToCart
                          productId={productId}
                          productData={item || {}}
                          btnVariant="outline"
                          btnClassName=" border-blue2 rounded-[8px] hover:bg-red2 hover:text-white hover:border-white "
                          // deliveryPayload={deliveryPayload}
                          isInStock={isInStock}
                        />
                      ) : (
                        <Link href={`/${pdpSeoUrl}`}>
                          <Button
                            variant={"outline"}
                            className={cn(
                              "border-blue2 rounded-[8px] w-full h-[32px] text-[10px] mb-[14px]"
                            )}
                          >
                            Contact Us To Order
                          </Button>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div> */}
        <Carousel
          opts={{
            align: "start",
          }}
          className="w-full p-0"
          setApi={setApi}
        >
          <CarouselContent>
            {frequentlyBoughtTogether?.map((item, index) => {
              const {
                thumbnail,
                productName,
                pdpSeoUrl,
                productId,
                price_details,
                isInStock,
                webPriceInactive,
              } = item || "";
              const { displayPrice, crossedPrice, cartPrice } =
                price_details || {};
              return (
                <CarouselItem
                  key={index}
                  className={cn(
                    "basis-1/3 m-0 1280:basis-1/2 viewedCard820:basis-full",
                    frequentlyBoughtTogether.length === index + 1
                      ? "border-none"
                      : "border-r px-5 mlg:border-r-0 mlg:pb-3 mlg:border-b mlg:pr-0"
                  )}
                >
                  <div className={cn("inline-flex items-center gap-3")}>
                    <div className="flex gap-3  items-center">
                      <Link href={pdpSeoUrl}>
                        <div className=" w-[132px] h-[132px] mob:w-[74px] mob:h-[74px]">
                          <DynamicImage
                            src={thumbnail}
                            alt="current product"
                            className=" object-contain h-full"
                            width={132}
                            height={132}
                          />
                        </div>
                      </Link>
                    </div>
                    <div className="text-black grid grid-rows-[auto,auto,auto] gap-2 ">
                      <TooltipProvider>

                      <Tooltip>
                        <TooltipTrigger asChild>
                          <h5 className="text-sm mb-1 font-semibold max-w-[350px] w-full min-h-[40px] three-line-dots">
                            {productName}
                          </h5>
                          {/* <Button variant="outline">Hover</Button> */}
                        </TooltipTrigger>
                        <TooltipContent side="bottom" align="start" className="max-w-[280px]"  >
                          <p>{productName}</p>
                        </TooltipContent>
                      </Tooltip>
                      </TooltipProvider>
                      {!webPriceInactive && (
                        <h3 className="text-[18px] leading-[27px] mb-[14px]">
                          ${cartPrice || displayPrice}{" "}
                          <span className="line-through text-xs">
                            {crossedPrice ? "$" + crossedPrice : ""}
                          </span>
                        </h3>
                      )}
                      <div className="flex justify-start">
                        {!webPriceInactive ? (
                          <AddToCart
                            productId={productId}
                            productData={item || {}}
                            btnVariant="outline"
                            btnClassName=" border-blue2 rounded-[8px] hover:bg-red2 hover:text-white hover:border-white "
                            // deliveryPayload={deliveryPayload}
                            isInStock={isInStock}
                          />
                        ) : (
                          <Link href={`/${pdpSeoUrl}`}>
                            <Button
                              variant={"outline"}
                              className={cn(
                                "border-blue2 rounded-[8px] w-full h-[32px] text-[10px] mb-[14px]"
                              )}
                            >
                              Contact Us To Order
                            </Button>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>
          {api?.scrollSnapList()?.length > 1 && (
            <div className=" grid grid-cols-[1fr_auto] items-center gap-3 px-[23px] pt-4 ">
              {/* Clickable Pagination Dots */}
              <div className="flex justify-center ">
                {Array.from({ length: count }).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-full h-1  transition-all ${
                      current === index + 1 ? "bg-black" : "bg-[#D0D0D0]"
                    }`}
                  />
                ))}
              </div>
              {/* Navigation Buttons */}
              <div className="flex items-center justify-end gap-3">
                <CarouselPrevious className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
                <div className="text-sm text-[#0C2340] font-medium">
                  {current}/{count}
                </div>
                <CarouselNext className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
              </div>
            </div>
          )}
        </Carousel>
      </div>
    </div>
  );
};

export default FrequentlyBoughtTogether;
